import React, { Fragment, useState, useRef, useEffect } from "react";
import _ from "lodash";
import RegisterFields from "./RegisterFields";
import formFields from "./formFields";
import { db } from "../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

export const RegisterForm = (props) => {
  const inputRef = useRef({});
  const [salesOptions, setSalesOptions] = useState([]);

  const renderFields = () => {
    return _.map(
      formFields,
      ({ label, name, type, options, required, description }) => {
        return (
          <RegisterFields
            name={name}
            label={label}
            type={type}
            value={
              name === "deviceNo"
                ? props.deviceNo
                : name === "incomingDate"
                ? new Date(props.incomingDate).toLocaleDateString("fr-CA", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })
                : undefined
            }
            options={name === "sales" ? salesOptions : options}
            required={required}
            onChange={props.onChange(name)}
            description={description}
            fileNames={props.fileNames}
            startDate={props.startDate}
            endDate={props.endDate}
          />
        );
      }
    );
  };

  useEffect(() => {
    inputRef.current = {};

    // Load sales representatives
    const loadSalesReps = async () => {
      try {
        const salesQuery = query(
          collection(db, "sales"),
          where("status", "==", "Available")
        );
        const salesSnapshot = await getDocs(salesQuery);
        const salesList = salesSnapshot.docs.map((doc) => doc.data().name.trim());
        setSalesOptions(salesList);
      } catch (error) {
        console.error("Error loading sales representatives:", error);
      }
    };

    loadSalesReps();
  }, []);

  return <Fragment>{renderFields()}</Fragment>;
};
